import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import history from "./store/history";
import Home from "./containers/Home";
import NotFoundPage from "./containers/NotFoundPage";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import StyledApp from "./styles/StyledApp";

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return React.createElement(component, finalProps);
};

const PublicRoute = ({ component, redirectTo, ...rest }) => (
  <Route
    {...rest}
    render={(routeProps) => renderMergedProps(component, routeProps, rest)}
  />
);

function App(props) {
  return (
    <ConnectedRouter history={history}>
      <StyledApp>
        <Header selected={props.navbar} history={history} />
        <Switch>
          <PublicRoute exact path={"/"} component={Home} />
          <Route path="*" component={NotFoundPage} />
        </Switch>
        <Footer history={history} />
      </StyledApp>
    </ConnectedRouter>
  );
}

function mapStateToProps(state = {}) {
  const { navbar } = state;
  return { navbar };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js